import { render, staticRenderFns } from "./HeaderDropdownAccount.vue?vue&type=template&id=35fa8705&scoped=true&"
import script from "./HeaderDropdownAccount.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownAccount.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDropdownAccount.vue?vue&type=style&index=0&id=35fa8705&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa8705",
  null
  
)

export default component.exports